import * as React from 'react';
import MarkdownRenderer from '../Editor/components/CropPageView/common/MarkdownRenderer';
import PrintDisclaimers from '../Editor/components/CropPageView/common/PageTypes/PrintDisclaimers';
import { productType } from '../../infrastructure/ProductType';
import './styles/TypeProductBrochure.css';
import './styles/TypeProductCatalog.css';
import './styles/TypeProductBulletin.css';
import './styles/TypeProductPostcard.css';
import './styles/TypeProductPoster.css';
import { IDocument } from 'src/infrastructure/interfaces';

export interface ITypeProduct {
  product: any;
  pageNumber?: number;
  document?: IDocument
}
interface ITypeProductState {
  loadedDetailImage?: any;
  inMemoryDetailImage?: string;
}

export default class TypeProduct extends React.Component<ITypeProduct, ITypeProductState> {
  image: any;

  constructor(props: ITypeProduct) {
    super(props);
    this.state = {
      loadedDetailImage: null,
      inMemoryDetailImage: undefined,
    }
  }

  componentDidMount() {
    if (!this.props.product.templateType) {
      this.checkHeight(this.image);
    }
    this.loadDetailImage();
  }

  componentWillReceiveProps() {
    if (!this.props.product.templateType) {
      this.checkHeight(this.image);
    }
  }

  loadDetailImage() {
    if (this.props.product.imageArea != null) {

      const imageFolder = require.context('../../../public/images/Products/',
                                          true,
                                          /\.(png|jpe?g|svg)$/,
                                          'lazy');
      const imageRelativePath = this.props.product.imageArea
          .replace("/images/Products/", "./")
          .replace("images/Products/", "./");
      // When uploading a new image, the image won't be in the context yet
      const hasImageInContext = imageFolder.keys().filter((key: string) => { return key == imageRelativePath}).length > 0;

      if (hasImageInContext) {
        imageFolder(imageRelativePath).then((loadedDetailImage: any) => {
          this.setState({
            loadedDetailImage,
            inMemoryDetailImage: undefined
          });
        });
      } else {
          this.setState({
            inMemoryDetailImage: this.props.product.imageArea
          });
      }
    }
  }

  checkHeight = (img: any) => {
    if (img) {
      img.onload = function () {
        img.classList.remove('wider');
        const w = this.width || this.clientWidth;
        const h = this.height || this.clientHeight;
        const widerRatio = 1.6;
        if (w / h > widerRatio && (w > this.parentNode.clientWidth / widerRatio)) {
          this.classList.add('wider');
        }
        img.onload = null;
      };
    }
  }

  createProductShelfImage(documentType: String, category: String) {
    const styleClassName = documentType + '-product-shelf-image';
    switch (category) {
      case "Adjuvant":
        return (<img src={require('../Editor/components/CropPageView/Bulletin/Images/shelfIcon_adjuvant.png')}
          className={styleClassName}>
        </img>);
      case "Crop Protection":
        return (<img src={require('../Editor/components/CropPageView/Bulletin/Images/shelfIcon_cropProtection.png')}
          className={styleClassName}>
        </img>);
      case "Plant Nutrition":
        return (<img src={require('../Editor/components/CropPageView/Bulletin/Images/shelfIcon_plantNutrition.png')}
          className={styleClassName}>
        </img>);
      case "Seed Treatment":
        return (<img src={require('../Editor/components/CropPageView/Bulletin/Images/shelfIcon_seedTreatment.png')}
          className={styleClassName}>
        </img>);
    }
    return null;
  }
  createBulletinProductShelf(category: String) {
    return(
      (category && (category.length > 0))?
        <div className={`bulletin-product-shelf`}>
            {this.createProductShelfImage('bulletin', category)}
            <span>{category}</span>
        </div>
      : null 
    )
  }
  
  createPageGroup(isCatalog: boolean, group: any, category_2: any) {
    const prefix = isCatalog ? "catalog" : "bulletin"
    return(
      (group && (group.length > 0))?
        <div className={`${prefix}-page-group`}>
            <div className={`group ${category_2.replace(/\//, '_')}`}>
              <table className="page-group-table">
                <tbody>
                <tr>
                  <td className="page-group-text-title">group</td>
                  <td><div className="page-group-triangle-left"></div></td>
                  <td><div className="page-group-group">{group}</div></td>
                  <td className="page-group-triangle-right-cell"><div className="page-group-triangle-right"></div></td>
                  <td className="page-group-text-description">
                    {(category_2 && (category_2.length > 0)) ? category_2 : "/"}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
        </div>
      : null 
    )
  }

  createCatalogHeader(logo: any, icon: any, isTopItemOnPage: boolean) {
    const containerClass = "catalog-drop-head";
    const containerClassFullName = isTopItemOnPage ? containerClass + " top-item-on-page" : containerClass;
    return (
      <div className={containerClassFullName}>
        {logo && <img className={`catalog-drop-logo`} alt="" src={logo} />}
        {icon && <img className={`catalog-drop-icon`} alt="" src={icon} />}
      </div>
    )
  }
  createBulletinPageHeader(logo: any, icon: any, group: any, category_2: any) {
    const hasGroup = (group && (group.length > 0));
    const iconClassName = hasGroup ? `bulletin-drop-icon-small` : `bulletin-drop-icon`;
    return (
      <div className={`bulletin-drop-head`}>
        <div className={`bulletin-drop-img-group`}>
          {logo && <img className={`bulletin-drop-logo`} alt="" src={logo} />}
          {icon && <img className={iconClassName} alt="" src={icon} />}
        </div>
        {this.createPageGroup(false, group, category_2)}
      </div>
    )
  }

  createDropStatement(isCatalog: boolean, statement: any) {
    const prefix = isCatalog ? "catalog" : "bulletin"
    return(
      <div className={`${prefix}-drop-statement`}>
        <MarkdownRenderer markdown={statement} />
      </div>
    )
  }

  createDropFeatures(isCatalog: boolean, features: any) {
    const prefix = isCatalog ? "catalog" : "bulletin"
    return(
      <div className={`${prefix}-drop-features`}>
        <span className={`${prefix}-drop-title`}>FEATURES</span>
        <MarkdownRenderer markdown={features} />
      </div>
    )
  }

  createDropRates(isCatalog: boolean, rates: any) {
    const prefix = isCatalog ? "catalog" : "bulletin"
    return(
      <div className={`${prefix}-drop-features`}>
        <span className={`${prefix}-drop-title`}>RATES</span>
        <div>{rates}</div>
      </div>
    )
  }

  createDropVariables(isCatalog: boolean, variableText: any) {
    const prefix = isCatalog ? "catalog" : "bulletin"
    return(
      variableText
        ? <div className={`${prefix}-drop-features`}>
          <span className={`${prefix}-drop-title`}>{variableText.title}</span>
            <MarkdownRenderer markdown={variableText.content} />
          </div>
        : null
    )
  }

  createDropRecs(isCatalog: boolean, recomendation_1: any, recomendation_2: any) {
    const prefix = isCatalog ? "catalog" : "bulletin"
    return(
      recomendation_1 ?
        <div className={`${prefix}-drop-features`}>
          <span className={`${prefix}-drop-title`}>MAXIMIZE PERFORMANCE WITH</span>
          <div className={`${prefix}-drop-recommendation-images`}>
            {recomendation_1 ? <img className={`${prefix}-drop-rec_1`} src={recomendation_1} alt="." /> : null}
            {recomendation_2 ? <span className={`${prefix}-drop-rec-or`}>OR</span> : null}
            {recomendation_2 ? <img className={`${prefix}-drop-rec_2`} src={recomendation_2} alt="." /> : null}
          </div>
        </div>
      : null
    )
  }

  createDropBenefits(isCatalog: boolean, grower_benefits: any) {
    const prefix = isCatalog ? "catalog" : "bulletin"
    return(
      <div className={`${prefix}-drop-features`}>
        <span className={`${prefix}-drop-title`}>GROWER BENEFITS</span>
        <MarkdownRenderer markdown={grower_benefits} />
      </div>
    )
  }

  createDropImageClass(isCatalog: boolean, isVertical: boolean): string {
    const prefix = isCatalog ? "catalog" : "bulletin"
    const suffix = isVertical ? "-vertical" : ""
    const returnVal = `${prefix}-drop-image-image${suffix}`;
    return returnVal;
  }
  createDropImage(isCatalog: boolean, isVertical: boolean): React.ReactNode {

    const imageClass = this.createDropImageClass(isCatalog, isVertical);
    if ((this.state.loadedDetailImage != null)
      && (this.state.loadedDetailImage.width != 0)) {
      return (<object data={this.state.loadedDetailImage}
                className={`${imageClass}`} />);
    } else if (this.state.inMemoryDetailImage != undefined) {
      return (<object data={this.state.inMemoryDetailImage}
        className={`${imageClass}`} />);
    } else if (this.props.product.imageArea != null) {
      return (<object data={this.props.product.imageArea}
              className={`${imageClass}`} />);
    }
  
    return <div></div>;
  }

  createDisclaimer(isCatalog: boolean, disclaimers: any) {
    const prefix = isCatalog ? "catalog" : "bulletin"

    const mainDisclaimer = {
      value: '',
      description: 'ALWAYS READ AND FOLLOW LABEL DIRECTIONS',
    };
    const printDisclaimers = disclaimers.filter((disclaimer: any) => { return disclaimer.value !== '#'; });
    printDisclaimers.unshift(mainDisclaimer);

    return(
      <div className={`${prefix}-drop-disclaimer`}>
        <PrintDisclaimers
          disclaimers={printDisclaimers}
          className={`${prefix}-drop-disclaimer-val`}
        />
      </div>
    )
  }

  createProductLink(link: string | null) {
    if ((link == null) || (link.length == 0)){
      return null;
    }
    return(
      <div className='product-hyperlink'>
        <a href={link}>
          Click to Learn More
        </a>
      </div>
    );
  }

  buildCatalogProduct(isVertical: boolean) {
    const {
      features,
      icon,
      logo,
      group,
      category_2,
      rates,
      grower_benefits,
      category,
      recomendation_1,
      recomendation_2,
      variableText,
      disclaimers,
      statement,
      url,
    } = this.props.product;

    const categoryNoSpaces = category.replace(' ', '');
    const hasGroupContent = (group && (group.length > 0));
    const imageDiv = this.createDropImage(true, isVertical);
    if (isVertical) {
      return (
        <div className={`catalog-page-container ${categoryNoSpaces}`}>
          <div className="catalog-page-drop">
            <div className="catalog-drop-content">
              { this.createPageGroup(true, group, category_2) }
              { this.createCatalogHeader(logo, icon, !hasGroupContent) }
              { this.createDropStatement(true, statement) }
              <div className="catalog-feature-body">
                <div className="catalog-feature-column">
                  { this.createDropFeatures(true, features) }          
                  { this.createDropRates(true, rates) }
                  { this.createDropVariables(true, variableText) }
                  { this.createDropRecs(true, recomendation_1, recomendation_2) }
                </div>
                <div className="catalog-feature-column-right">
                  { this.createDropBenefits(true, grower_benefits) }
                </div>
              </div>
              { imageDiv }
              { this.createProductLink(url)}
              { this.createDisclaimer(true, disclaimers) }
            </div>
          </div>
        </ div>
      );
    } else {
      return (
        <div className={`catalog-page-container ${categoryNoSpaces}`}>
          <div className="catalog-page-drop">
            <div className="catalog-drop-content">
              { this.createPageGroup(true, group, category_2) }
              { this.createCatalogHeader(logo, icon, !hasGroupContent) }
              { this.createDropStatement(true, statement) }
              <div className="catalog-feature-body">
                <div className="catalog-feature-row">
                  <div className="catalog-feature-column">
                    { this.createDropFeatures(true, features) }
                  </div>
                  <div className="catalog-feature-column-right">
                    { this.createDropBenefits(true, grower_benefits) }
                  </div>
                </div>
                <div className="catalog-feature-row">
                  <div className="catalog-feature-column">        
                    { this.createDropRates(true, rates) }
                  </div>
                  <div className="catalog-feature-column-right">
                    { this.createDropVariables(true, variableText) }
                    { this.createDropRecs(true, recomendation_1, recomendation_2) }
                  </div>
                </div>
              </div>
              { imageDiv }
              { this.createProductLink(url)}
              { this.createDisclaimer(true, disclaimers) }
            </div>
          </div>
        </ div>
      );
    }
  }

  buildBulletinProduct(isVertical: boolean) {
    const {
      features,
      icon,
      logo,
      group,
      category,
      category_2,
      rates,
      grower_benefits,
      recomendation_1,
      recomendation_2,
      variableText,
      statement,
      url,
    } = this.props.product;

    if (isVertical) {
      return (
        <div className="bulletin-page-container">
          <div className="bulletin-page-drop">
            { this.createBulletinProductShelf(category) }
            <div className="bulletin-drop-content">
              { this.createBulletinPageHeader(logo, icon, group, category_2) }
              { this.createDropStatement(false, statement) }
              <div className="bulletin-feature-body">
                <div className="bulletin-feature-column">
                  { this.createDropFeatures(false, features) }          
                  { this.createDropRates(false, rates) }
                  { this.createDropVariables(false, variableText) }
                  { this.createDropRecs(false, recomendation_1, recomendation_2) }
                </div>
                <div className="bulletin-feature-column-right">
                  { this.createDropBenefits(false, grower_benefits) }
                </div>
              </div>
              { this.createDropImage(false, isVertical) }
              { this.createProductLink(url)}
            </div>
          </div>
          <div className="bulletin-page-footer"></div>
        </ div>
      );
    }

    // Template B
    return (
      <div className="bulletin-page-container">
        <div className="bulletin-page-drop">
          { this.createBulletinProductShelf(category) }
          <div className="bulletin-drop-content">
            { this.createBulletinPageHeader(logo, icon, group, category_2) }
            { this.createDropStatement(false, statement) }
            <div className="bulletin-feature-body">
              <div className="bulletin-feature-row">
                <div className="bulletin-feature-column">
                  { this.createDropFeatures(false, features) }
                </div>
                <div className="bulletin-feature-column-right">
                  { this.createDropBenefits(false, grower_benefits) }         
                </div>
              </div>
              <div className="bulletin-feature-row">
                <div className="bulletin-feature-column">
                  { this.createDropVariables(false, variableText) }
                </div>
                <div className="bulletin-feature-column-right">
                  { this.createDropRates(false, rates) }
                </div>
              </div>
              <div className="bulletin-feature-row">
                <div className="bulletin-feature-column">
                </div>
                <div className="bulletin-feature-column-right">
                  { this.createDropRecs(false, recomendation_1, recomendation_2) }
                </div>
              </div>
            </div>
            { this.createDropImage(false, isVertical) }
            { this.createProductLink(url)}
          </div>
        </div>
        <div className="bulletin-page-footer"></div>
      </ div>
    );
  }

  buildBrochureProduct() {
    const {
      features,
      icon,
      logo,
      group,
      rates,
      category,
      statement,
    } = this.props.product;
    const categoryIcon = `/images/Products/Icons for Product Category/${category}.svg`;

    return (
      <div>
        <div className="brochure-page-drop">
          <div className="brochure-drop-content">
            <div className="brochure-drop-head">
              {logo && <img className="brochure-drop-logo" alt="" src={logo} ref={(img) => { this.image = img; }} />}
              {icon && <img className="brochure-drop-icon" alt="" src={icon} />}
            </div>
            <div className="brochure-drop-line">
              <div className="brochure-drop-line-left">
                  <img src={categoryIcon} alt={`${category}`} className="brochure-drop-line-ico" />
                  <span className="brochure-drop-category">{category}</span>   
              </div>
              <div className="brochure-drop-line-right">
              {group && <span className="brochure-drop-group"><b>GROUP: </b><span>{group}</span></span>}
              </div>
            </div>
            <MarkdownRenderer className={"brochure-drop-cont"} markdown={statement} />
            <div className="brochure-drop-benefits">
              <span className="brochure-drop-title">GROWER BENEFITS:</span>
              <MarkdownRenderer markdown={features} />
            </div>
            <div className="brochure-drop-benefits">
              <span className="brochure-drop-title">rates:</span>
              <span className="brochure-drop-rates-val">{rates}</span>
            </div>
          </div>
        </div>
      </ div>
    );
  }

  buildPostcardProduct() {
    const {
      features,
      icon,
      logo,
      group,
      rates,
      category,
      statement,
    } = this.props.product;
    const categoryIcon = `/images/Products/Icons for Product Category/${category}.svg`;

    return (
      <div>
        <div className="postcard-page-drop">
          <div className="brochure-drop-content">
            <div className="postcard-drop-head">
              {logo && <img className="postcard-drop-logo" alt="" src={logo} ref={(img) => { this.image = img; }} />}
              {icon && <img className="postcard-drop-icon" alt="" src={icon} />}
            </div>
            <div className="postcard-drop-line">
              <div className="postcard-drop-line-left">
                  <img src={categoryIcon} alt={`${category}`} className="postcard-drop-line-ico" />
                  <span className="postcard-drop-category">{category}</span>   
              </div>
              <div className="postcard-drop-line-right">
              {group && <span className="brochure-drop-group"><b>GROUP: </b><span>{group}</span></span>}
              </div>
            </div>
            <MarkdownRenderer className={"postcard-drop-cont"} markdown={statement} />
            <div className="postcard-drop-benefits">
              <span className="postcard-drop-title">GROWER BENEFITS:</span>
              <MarkdownRenderer markdown={features} />
            </div>
            <div className="postcard-drop-benefits">
              <span className="postcard-drop-title">rates:</span>
              <span className="postcard-drop-rates-val">{rates}</span>
            </div>
          </div>
        </div>
      </ div>
    );
  }

  buildPosterProduct() {
    const {
      features,
      icon,
      logo,
      group,
      rates,
      category,
      statement,
    } = this.props.product;
    const categoryIcon = `/images/Products/Icons for Product Category/${category}.svg`;

    return (
      <div>
        <div className="postcard-page-drop">
          <div className="brochure-drop-content">
            <div className="poster-drop-head">
              {logo && <img className="poster-drop-logo" alt="" src={logo} ref={(img) => { this.image = img; }} />}
              {icon && <img className="poster-drop-icon" alt="" src={icon} />}
            </div>
            <div className="poster-drop-line">
              <div className="poster-drop-line-left">
                  <img src={categoryIcon} alt={`${category}`} className="poster-drop-line-ico" />
                  <span className="poster-drop-category">{category}</span>   
              </div>
              <div className="poster-drop-line-right">
              {group && <span className="brochure-drop-group"><b>GROUP: </b><span>{group}</span></span>}
              </div>
            </div>
            <MarkdownRenderer className={"poster-drop-cont"} markdown={statement} />
            <div className="poster-drop-benefits">
              <span className="poster-drop-title">GROWER BENEFITS:</span>
              <MarkdownRenderer markdown={features} />
            </div>
            <div className="poster-drop-benefits">
              <span className="poster-drop-title">rates:</span>
              <span className="poster-drop-rates-val">{rates}</span>
            </div>
          </div>
        </div>
      </ div>
    );
  }



  render() {
    if (this.props.document) {
      if (this.props.document.type == "Postcard") {
        return this.buildPostcardProduct();
      }

      if (this.props.document.type == "Poster") {
        return this.buildPosterProduct();
      }
    }
    

    const isBrochureTemplate = productType.Brochure.toUpperCase() == this.props.product.type.toUpperCase();
    if (isBrochureTemplate) {
      return this.buildBrochureProduct();
    }

    
    const isCatalogTemplate = productType.Catalog.toUpperCase() == this.props.product.type.toUpperCase();
    if (isCatalogTemplate) {
      var catalogDiv = <div></div>
      switch (this.props.product.templateType.toUpperCase()) {
        
        case "TYPE1": {
          catalogDiv = this.buildCatalogProduct(true);
          break;
        }
        case "TYPE2": {
          catalogDiv = this.buildCatalogProduct(false);
          break;
        }
        default: {
          catalogDiv = this.buildCatalogProduct(true);
          break;
        }
      }
      return catalogDiv;
    }

    switch (this.props.product.templateType.toUpperCase()) {
      case "TYPE1": {
        return this.buildBulletinProduct(true);
      }
      case "TYPE2": {
        return this.buildBulletinProduct(false);
      }
      default: {
        return this.buildBulletinProduct(true);
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/Products/TypeProduct.tsx